var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectFloor10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2500,
    height: 1270,
    viewBox: "0 0 2500 1270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: 3,
    d: "M501.5 163V107H232V272H181V385.5H130V577.5H608.5V461H492V163H501.5Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: 4,
    d: "M675 526.5H608.5V461H492V163H501.5V107H772V179.5H749.5V552H675V526.5Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: 5,
    d: "M876 552H749.5V179.5H772V131.5H1017V459H942.5V527H876V552Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: 6,
    d: "M942.5 578V527V459H1017V131.5H1261V178.5H1283.5V570H1096.5V578H942.5Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: 9,
    d: "M1261 85V132V178.5H1283.5V570H1360.5V577.5H1576.5V521H1603.5V458H1531.5V191.5H1536.5V85H1261Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: 10,
    d: "M1753.5 521H1603.5V458H1531.5V191.5H1536.5V85H1788.5V509.5H1753.5V521Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: 11,
    d: "M1948.5 509.5H1788.5V85H2046V458.5H1948.5V509.5Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: 12,
    d: "M1948.5 577.5V509.5V458.5H2046V85H2401V577.5H1948.5Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: 13,
    d: "M1948.5 696.5V577.5H2401V980H2316.5V1069H2046V696.5H1948.5Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: 14,
    d: "M1797.5 634H1948.5V696.5H2046V1069H1776V973.5H1797.5V634Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: 8,
    d: "M1576.5 643.5V577.5H1360.5V570H1283.5V1071H1540.5V713.5H1603.5V643.5H1576.5Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: 7,
    d: "M1096.5 570H1283.5V1071H1008V712.5H942.5V578H1096.5V570Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: 2,
    d: "M130 577.5H608.5V665H601V715H493.5V1006.5H502V1070.5H231V882.5H181V770H130V577.5Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: 1,
    d: "M772 1070.5H502V1006.5H493.5V715H601V665H608.5V632H769V696H749V974.5H772V1070.5Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectFloor10);
export default __webpack_public_path__ + "static/media/select-floor-10.6c42dad9.svg";
export { ForwardRef as ReactComponent };